import React, { useEffect, useState } from 'react';
import { Box, MenuItem, Paper, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import PageHeader from '../components/layout/PageHeader';
import ActivityList from '../components/activity/ActivityList';
import UserService from '../services/UserService';
import { usePageRefresh } from '../components/layout/pullToRefresh';

/** The firm's whole activity log (admins): who changed what on clients and jobs, filterable by person and date. */
export default function ActivityPage() {
    const { t } = useTranslation();
    const [people, setPeople] = useState([]);
    const [userId, setUserId] = useState('');
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');
    const [version, setVersion] = useState(0);
    usePageRefresh(() => setVersion(v => v + 1));

    useEffect(() => { UserService.directory().then(setPeople).catch(() => {}); }, []);

    return (
        <Layout>
            <PageHeader title={t('activity.title')} subtitle={t('activity.subtitle')} />
            <Box sx={{ bgcolor: '#fff', border: '1px solid #E2E8F0', borderRadius: '14px', p: 1.5, mb: 2.5, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                <TextField select size="small" label={t('activity.person')} value={userId} onChange={(e) => setUserId(e.target.value)} sx={{ minWidth: 220, flex: '1 1 220px' }}
                           slotProps={{ select: { displayEmpty: true }, inputLabel: { shrink: true } }}>
                    <MenuItem value="">{t('activity.everyone')}</MenuItem>
                    {people.map(p => <MenuItem key={p.id} value={p.id}>{p.firstName} {p.lastName}</MenuItem>)}
                </TextField>
                <TextField size="small" type="date" label={t('activity.from')} value={from} onChange={(e) => setFrom(e.target.value)}
                           slotProps={{ inputLabel: { shrink: true } }} sx={{ flex: '1 1 160px' }} />
                <TextField size="small" type="date" label={t('activity.to')} value={to} onChange={(e) => setTo(e.target.value)}
                           slotProps={{ inputLabel: { shrink: true } }} sx={{ flex: '1 1 160px' }} />
            </Box>
            <Paper elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: '14px', overflow: 'hidden' }}>
                <ActivityList userId={userId} from={from} to={to} showSubject pageSize={30} reloadKey={version} />
            </Paper>
        </Layout>
    );
}
